import {CtControlConfiguration} from "@ctsolution/ct-framework";

export const ItemSearchControl: CtControlConfiguration = <CtControlConfiguration>{
  name: "itemSearch",
  label: "itemSearch.placeholder"
};
